import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config';
import SpecialtyEditor from './SpecialtyEditor';
import './SpecialtiesManager.css';

export default function SpecialtiesManager() {
  const { authenticatedFetch } = useAuth();
  const [specialties, setSpecialties] = useState([]);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    const res = await authenticatedFetch(`${API_BASE_URL}/api/specialties/admin/all`);
    setSpecialties(res.ok ? await res.json() : []);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function onDelete(id) {
    if (!window.confirm('Delete this specialty?')) return;
    await authenticatedFetch(`${API_BASE_URL}/api/specialties/${id}`, { method: 'DELETE' });
    load();
  }

  if (editing !== null) {
    return (
      <SpecialtyEditor
        specialty={editing === 'new' ? null : editing}
        onDone={() => { setEditing(null); load(); }}
        onCancel={() => setEditing(null)}
      />
    );
  }

  return (
    <div className="specialties-manager">
      <div className="specialties-manager-head">
        <h2>Specialties</h2>
        <button className="btn-primary" onClick={() => setEditing('new')}>+ Add Specialty</button>
      </div>
      {loading ? <p>Loading...</p> : (
        <table className="specialties-table">
          <thead>
            <tr><th>Order</th><th>Name</th><th>Slug</th><th>Published</th><th></th></tr>
          </thead>
          <tbody>
            {specialties.map((s) => (
              <tr key={s.id}>
                <td>{s.sortOrder}</td>
                <td>{s.name}</td>
                <td>{s.slug}</td>
                <td>{s.published ? 'Yes' : 'No'}</td>
                <td>
                  <button className="btn-secondary" onClick={() => setEditing(s)}>Edit</button>
                  <button className="btn-danger" onClick={() => onDelete(s.id)}>Delete</button>
                </td>
              </tr>
            ))}
            {specialties.length === 0 && <tr><td colSpan="5" style={{ color: 'var(--color-text-muted)' }}>No specialties yet.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}
